







































import Vue from 'vue'
import { titleize } from 'underscore.string'

export default Vue.extend({
  name: "user-page",
  props: {
    resource: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      signInProviders: [
        {
          key: 'google.com',
          icon: "google_icon.svg",
          name: "Google"
        },
        {
          key: 'microsoft.com',
          icon: "mssymbol_19.svg",
          name: "Microsoft"
        }
      ]
    }
  },

  computed: {
    title():string { return titleize(this.resource) },
    providers():object[] { 
      return this.signInProviders.filter(provider => {
        return !this.$store.state.auth.user.providerData.find((_provider:{providerId:string}) => {
          return provider.key == _provider.providerId 
        })
      })
    }
  },

  methods: {
    connectProvider(name:string) {
      //@ts-ignore
      const provider = (key) => {
        if (key == 'google.com') {
          //@ts-ignore
          return new this.$firebase.auth.GoogleAuthProvider()
        } else if (key == 'microsoft.com') {
          //@ts-ignore
          return new this.$firebase.auth.OAuthProvider('microsoft.com')
        }
      }
      if (this.$auth.currentUser) {
        this.$auth.currentUser.linkWithPopup(provider(name)).then(result => {
          alert("Account linked successfully!")
        }).catch(error => {
          alert(error.message)
        })
      }
    }
  },

  filters: {

  },
  created() {

  },
  mounted() {

  },
  updated() {
    
  }
})
